export default "__VITE_ASSET__bF2FXELA__"